<form #callCheckList="ngForm" (ngModelChange)="checkFormValidity()">
  <div>
    <div class="box-body">
      <p class="centered-border1">Call Checklist</p>
      <div class="orderentrydiv">
        @if (isFirstOrderNotice) {
          <div class="col-sm-5 form-group">
            <label class="font-label-text">When was odor first noticed?</label>
          </div>
        }
        @if (!isFirstOrderNotice) {
          <div class="col-sm-5 form-group">
            <label class="font-label-text required-label">When was odor first noticed? *</label>
          </div>
        }
        <div class="col-sm-6 form-group">
          <app-textinput [(ngModel)]="odorfirstnoticed" name="odorfirstnoticed"
            (valueChange)="onodorfirstnoticedChange($event)" [required]="true"
          [placeholder]="'Enter odor first noticed'" [maxlength]="30" #odorfirstnoticedRef="ngModel"></app-textinput>
          @if (!isFirstOrderNotice && odorfirstnoticed == '') {
            <div class="text-danger Validation">
              Enter odor first noticed.
            </div>
          }
        </div>
      </div>
      <hr>
        <div class="orderentrydiv">
          <div class="col-sm-5 form-group">
            <label class="font-label-text required-label">Caller Type: *</label>
          </div>
          <div class="col-sm-6 form-group">
            <app-radio-button [options]="callerTypes" name="callerTypes" [(ngModel)]="callerTypeValue"
              (onClick)="oncallerTypesChange($event)" class="font-label-text">
            </app-radio-button>
          </div>
        </div>
        <hr>
          <div class="orderentrydiv">
            <div class="col-sm-5 form-group">
              <label class="font-label-text">
                @if (!isFirstOrderNotice) {
                  <span class="required-label"> Sound of escaping gas: *</span>
                }
                @if (isFirstOrderNotice) {
                  <span> Sound of escaping gas:</span>
                }
              </label>
            </div>
            <div class="col-sm-6 form-group">
              <app-radio-button [options]="soundGas" name="soundGas" [(ngModel)]="soundGasValue"
                (onClick)="onSoundGasChange($event)" class="font-label-text">
              </app-radio-button>
              @if (!isFirstOrderNotice && soundGasValue == '') {
                <div class="text-danger Validation">
                  Enter Sound of escaping gas.
                </div>
              }
            </div>
          </div>
          <hr>
            @if (orderTypeConfig.leakageVisibilty) {
              <div class="orderentrydiv">
                <div class="col-sm-5 form-group">
                  <label class="font-label-text" [ngClass]="{'required-label': orderTypeConfig.leakageRequired}">Is Leakage
                  inside or outside? *</label>
                </div>
                <div class="col-sm-6 form-group">
                  <app-radio-button [options]="leakageType" name="leakageType" [(ngModel)]="leakageValue"
                    (onClick)="onleakageTypeChange($event)" class="font-label-text">
                  </app-radio-button>
                  @if (!isEmerComments && !orderTypeConfig.leakageRequired) {
                    <div class="text-danger Validation">
                      Leakage inside or outside is required.
                    </div>
                  }
                </div>
              </div>
            }
            <div class="container">
              <br>
                <div class="orderentrycallChecklist mb-3">
                  <div class="col-sm-6">
                    <div class="panel inside-panel">
                      <h4 class="panel-header">If Inside:</h4>
                      <div class="orderentrydiv">
                        <div class="col-sm-12 form-group">
                  <label class="font-label-text" [ngClass]="{'required-label': checkLeakageTypeInside() && 
                  orderTypeConfig.inside.typeOfBuildingRequired}">Type of building:</label>
                          <app-dropdown [options]="buildingDropdownOptions" [(ngModel)]="buildingSelectedValue"
                            name="buildingSelectedValue" #stateRef="ngModel" [validationName]="'Building'"
                            [selectedValue]="buildingSelectedValue" [isFormSubmitted]="true"
                            [required]="checkLeakageTypeInside() && orderTypeConfig.inside.typeOfBuildingRequired"
                            (selectedValueChange)="onBuildingChange($event)" placeholder="">
                          </app-dropdown>
                        </div>
                      </div>
                      <div class="orderentrydiv">
                        <div class="col-sm-7 form-group">
                          <label class="font-label-text"
                            [ngClass]="{'required-label': checkLeakageTypeInside() && orderTypeConfig.inside.whichRoomRequired}">Which
                          room?</label>
                          <app-textinput [inputlabel]="'Room'" [(ngModel)]="roomValue" name="roomValue" [maxlength]="10"
                            [isrequired]="checkLeakageTypeInside() && orderTypeConfig.inside.whichRoomRequired"
                            (valueChange)="onRoomChange($event)" [placeholder]="'Enter Room'"
                          #roomRef="ngModel"></app-textinput>
                          @if (!isEmerComments && !roomValue && leakageValue == 'Inside' && isLeakageEnabled) {
                            <div
                              class="text-danger Validation">
                              Room is required.
                            </div>
                          }
                        </div>
                      </div>
                      <div class="orderentrydiv">
                        <div class="col-sm-12 form-group">
                          <label
                            [ngClass]="{'required-label': checkLeakageTypeInside() &&  orderTypeConfig.inside.isLeakAtApplianceRequired}">Is
                          leak at an appliance?</label>
                          <app-radio-button [options]="isYesNo" name="isLeakApplianceValue" [(ngModel)]="isLeakApplianceValue"
                            [isRequired]="checkLeakageTypeInside() && orderTypeConfig.inside.isLeakAtApplianceRequired"
                            [disabled]="false" (onClick)="onLeakApplianceChange($event)" class="font-label-text">
                          </app-radio-button>
                          @if (!isEmerComments && !isLeakApplianceValue && leakageValue == 'Inside' && isLeakageEnabled) {
                            <div
                              class="text-danger Validation">
                              Leak Appliance is required.
                            </div>
                          }
                        </div>
                      </div>
                      <div class="orderentrydiv">
                        <div class="col-sm-12 form-group">
                  <label class="font-label-text" [ngClass]="{'required-label': checkLeakageTypeInside() &&
                    isLeakApplianceValue !== 'No' && orderTypeConfig.inside.applianceRequired}">Appliance:</label>
                          <app-textinput [inputlabel]="'Appliance'" [(ngModel)]="applianceValue" name="applianceValue"
                    (valueChange)="onApplianceChange($event)" [maxlength]="20" [isrequired]="checkLeakageTypeInside() &&
                    isLeakApplianceValue !== 'No'
                    && orderTypeConfig.inside.applianceRequired" [placeholder]="'Enter Appliance'"
                          #applianceRef="ngModel"></app-textinput>
                          @if (!isEmerComments && !applianceValue && leakageValue == 'Inside' && isLeakageEnabled) {
                            <div
                              class="text-danger Validation">
                              Appliance is required.
                            </div>
                          }
                        </div>
                      </div>
                      <div class="orderentrydiv">
                        <div class="col-sm-9 form-group">
                  <label class="font-label-text" [ngClass]="{'required-label': checkLeakageTypeInside() && 
                  orderTypeConfig.inside.leakInHousePipingRequired}">Is leak in house piping?</label>
                          <app-radio-button [options]="isYesNo" name="isLeakHousePipingValue"
                            [isRequired]="checkLeakageTypeInside() && orderTypeConfig.inside.leakInHousePipingRequired"
                            [(ngModel)]="isLeakHousePipingValue" (onClick)="onLeakHousePipingChange($event)"
                            class="font-label-text">
                          </app-radio-button>
                          @if (!isEmerComments && !isLeakHousePipingValue && leakageValue == 'Inside' && isLeakageEnabled) {
                            <div
                              class="text-danger Validation">
                              Leak House Piping is required.
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="panel outside-panel">
                      <h4 class="panel-header">If Outside:</h4>
                      <div class="orderentrydiv">
                        <div class="col-sm-12 form-group">
                  <label class="font-label-text" [ngClass]="{'required-label': checkLeakageTypeOutside() && 
                  orderTypeConfig.outSide.whereLeakLocatedRequired}">Where is leak located?</label>
                          <app-dropdown [options]="leakedDropdownOptions" [(ngModel)]="leakedSelectedValue"
                            name="leakedSelectedValue" #isLeakLocatedValueRef="ngModel" [validationName]="'Leak Location'"
                    [required]="checkLeakageTypeOutside() && 
                    orderTypeConfig.outSide.whereLeakLocatedRequired" [isFormSubmitted]="true"
                            [selectedValue]="leakedSelectedValue" (selectedValueChange)="onLeakLocatedChange($event)"
                            placeholder="">
                          </app-dropdown>
                        </div>
                      </div>
                      <div class="orderentrydiv">
                        <div class="col-sm-12 form-group">
                          <label class="font-label-text"
                            [ngClass]="{'required-label': checkLeakageTypeOutside() && orderTypeConfig.outSide.addLocationCommentsRequired}">Additional
                          Outside location comments:</label>
                  <app-text-area placeholder="Enter Additional Outside location comments." [isrequired]="checkLeakageTypeOutside() &&
                     orderTypeConfig.outSide.addLocationCommentsRequired" name="additionaloutsidelocation"
                            [(ngModel)]="additionaloutsidelocation" (change)="onadditionaloutsidelocationChange($event)"
                            [cols]="30" [rows]="4">
                          </app-text-area>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
                <div class="orderentrydiv">
                  <div class="col-sm-7 form-group ">
                    <label class="font-label-text">Any type of construction work in progress (inside or outside)?</label>
                    <app-radio-button [options]="isYesNo" name="workInProgressValue" [(ngModel)]="workInProgressValue"
                      (onClick)="onworkInProgressChange($event)" class="font-label-text">
                    </app-radio-button>
                  </div>
                  <div class="col-sm-3 form-group">
                    <label class="font-label-text">Type:</label>
                    <app-textinput [(ngModel)]="typeValue" name="typeValue" [maxlength]="20" (valueChange)="onTypeChange($event)"
                    [placeholder]="'Enter Type'" #typeRef="ngModel"></app-textinput>
                  </div>
                </div>
                <hr>
                  <div class="orderentrydiv">
                    <div class="col-sm-12 form-group">
                      <label>
                        <span class="font-label-text required-label">Additional Emergency Details *</span>
                      </label>
                      <br>
                        <app-text-area placeholder="Enter Additional Emergency Details." name="additionalEmergencyValue"
                          [(ngModel)]="additionalEmergencyValue" [customErrorMessage]="'Enter Additional Emergency Details.'"
                          (change)="onadditionalEmergencyChange($event)" [cols]="69" [rows]="5" [required]="true">
                        </app-text-area>
                      </div>
                    </div>
                  </div>
                </div>
              </form>